import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../../components/table/ResultTable";
import ResultText from "../ResultText";
import CheckCSName from "../CheckCSName";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultBody from "../../../components/table/ResultBody";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import EmptyLine from "../EmptyLine";
import {useUser} from "../../../context/UserContext";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultView from "../../../components/ResultView";

export function B4({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.RT01.error_id: {
            return (
                <>
                    <ResultText>
                        Contraction/expansion coefficients are different than the recommended values of {settings?.defaults?.cont_coef_structure_xs}/{settings?.defaults?.exp_coef_structure_xs} at the following {row?.data?.length} structure cross sections:
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>
                                    River Station
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                    Con/Exp
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                    Section
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(25), textAlign: 'right'}}>
                                    Structure RS
                                </ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(x => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            <CheckCSName csName={x.cross_section} csNameVal={x.cross_section} />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>
                                            {x.cont}/{x.exp}
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>
                                            Section {x.number}
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>
                                            {x.type} at RS {x.culvert}
                                        </ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.RT02.error_id: {
            return (
                <>
                    <ResultText>
                        Contraction/expansion coefficients are different than the recommended values of {`${settings?.defaults?.cont_coef_natural_xs}/${settings?.defaults?.exp_coef_natural_xs}`} at the following {row?.data?.length} natural cross sections:
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>
                                    River Station
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                    Con/Exp
                                </ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(x => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            <CheckCSName csName={x.cross_section} csNameVal={x.cross_section} />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>
                                            {x.cont}/{x.exp}
                                        </ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.RT06.error_id: {
            return (
                <>
                    <ResultText>
                        Culvert Entrance or Exit Loss Coefficient is not within the recommended (entrance 0.2-0.9, exit 0.3-1.0) limits for the following {row?.data?.length} culverts.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(10)}}>
                                    River Station
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(10)}}>
                                    Culvert
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                    Entrance
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                    Exit
                                </ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(x => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            <CheckCSName csName={x.cross_section} csNameVal={x.cross_section} />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            {x.culvert_name}
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right', color: (x.entrance_coeff < 0.2 || x.entrance_coeff > 0.9) ? 'red' : ''}}>
                                            {x.entrance_coeff}
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right', color: (x.exit_coeff < 0.3 || x.exit_coeff > 1.0) ? 'red' : ''}}>
                                            {x.exit_coeff}
                                        </ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.RT07.error_id: {
            return (
                <>
                    <ResultText>
                        Culvert Manning's n value is not within the recommended (0.010, 0.035) limits for the following {row?.data?.length} culverts.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(12)}}>
                                    River Station
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(10)}}>
                                    Culvert
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(18), textAlign: 'right'}}>
                                    Manning's n Top
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(18), textAlign: 'right'}}>
                                    Manning's n Bottom
                                </ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(x => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            <CheckCSName csName={x.cross_section} csNameVal={x.cross_section} />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            {x.culvert_name}
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right', color: (x.mann_top < 0.010 || x.mann_top > 0.035) ? 'red' : ''}}>
                                            {x.mann_top}
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right', color: (x.mann_bottom < 0.010 || x.mann_bottom > 0.035) ? 'red' : ''}}>
                                            {x.mann_bottom}
                                        </ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.RT08.error_id: {
            return (
                <>
                    <ResultText>
                        Weir Flow Coefficient is not within the recommended (2.5, 4.0) limits for the following {row?.data?.length} culverts.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(12)}}>
                                    River Station
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(10)}}>
                                    Culvert
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(20), textAlign: 'right'}}>
                                    Weir Flow Coefficient
                                </ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(x => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            <CheckCSName csName={x.cross_section} csNameVal={x.cross_section} />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            {x.culvert_name}
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right', color: (x.weir_coef < 2.5 || x.weir_coef > 4.0) ? 'red' : ''}}>
                                            {x.weir_coef}
                                        </ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}